<template>
    <div class="showtandem" v-if="isDefect">
        <div style="margin-left:578px;margin-top: 1px;">
            <img src="../assets/img/close.png" style="width: 24px;height: 18px" @click.self="hideSelf" title="close">
        </div>
        <h2 style="text-align: center;margin: 10px auto;color: #275015">Tandem gene of {{target}}</h2>
        <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin: 20px auto 0px 164px;" label-width="200px">
            <el-button style="width: 280px" @click="tandemPairResult">Click here for more detail</el-button>
            <h2 class="warning_label">Low score tandem array warning!</h2>
            <!-- <el-form-item label="Low score tandem array warning!"> -->
            <!-- </el-form-item> -->
        </el-form>
        <div id="tandem_sheet" v-for="gene in tandem_gene_list" :key="gene">
            <div id="tandem_gene">
                <button @click="tandemFunctionSelection(gene)" class="search_gene_button">{{gene}}</button>
            </div>
        </div>
        <router-view/>
    </div>

    <div class="showtandem" v-else>
        <div style="margin-left:578px;margin-top: 1px;">
            <img src="../assets/img/close.png" style="width: 24px;height: 18px" @click.self="hideSelf" title="close">
        </div>
        <h2 style="text-align: center;margin: 10px auto;color: #275015">Tandem gene of {{target}}</h2>
        <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin: 20px auto 10px 164px;" label-width="200px">
            <el-button style="width: 280px" @click="tandemPairResult">Click here for more detail</el-button>
        </el-form>
        <div id="tandem_sheet" v-for="gene in tandem_gene_list" :key="gene">
            <div id="tandem_gene">
                <button @click="tandemFunctionSelection(gene)" class="search_gene_button">{{gene}}</button>
            </div>
        </div>
        <router-view/>
    </div>

</template>

<script>
    import axios from 'axios';
    export default {
        name: "ShowAth10TandemArray",
        props: ['target'],
        data() {
            return {
                tandem_gene_list: [],
                isDefect: 0,
            }
        },
        mounted() {
            this.searchtandem()
        },
        methods: {
            searchtandem() {
                var target = this.target;
                axios({
                    url: 'http://39.100.233.196:8001/api/search-Ath10-tandem/',
                    type: 'json',
                    params: {
                        target
                    },
                    method: 'get',
                }).then((res)=>{
                    // console.log(res.data)
                    this.tandem_gene_list = res.data[0]
                    this.isDefect = res.data[1]
                })
            },
            tandemPairResult() {
                var target = this.target;
                let routeUrl = this.$router.resolve({
                    path: "../SearchTandemPairResult/",
                    query: {Gene: target}
                });
                window.open(routeUrl.href, '_blank')
            },
            searchTandemGene(gene) {
                // console.log(gene)
                this.$emit("searchTandemGene", gene)
            },
            tandemFunctionSelection(gene) {
                this.$emit("tandemFunctionSelection", gene)
                // console.log(gene)
            },
            hideSelf() {
                this.$emit("hideBox");
            },
        }
    }
</script>

<style>
    .showtandem {
        position: fixed;
        width: 600px;
        /*height: 200px;*/
        background: #77B07F;
        left: 0;
        right: 0;
        top: 30%;
        margin: 0 auto;
    }

    .showtandem #tandem_sheet #tandem_gene{
        float: left;
        text-align: center;
        width: 200px;
        margin-top: 5px;
        margin-bottom: 10px;
    }

    .showtandem #tandem_sheet #tandem_gene .search_gene_button {
        margin: auto;
        font-size: 20px;
        color: #ffffff;
        background: #77B07F;
        border: 0px;
        height: 40px;
    }

    .showtandem #tandem_sheet #tandem_gene .search_gene_button:hover {
        color: #333a61;
    }

    .showtandem .warning_label {
        color: #e90a0a;
        font-weight: bolder;
        margin-top: 10px;
        font-size: 19px;
    }

    .showtandem .el-button {
        background-color: #E1E1E1;
        color: #407338;
        border: #ADADAD;
        font-size: 16px;
    }

    .showtandem .el-button:hover {
        background-color: #E5F1FB;
        color: black;
    }
</style>